import { Flex, Text } from "@chakra-ui/layout";
import { useMemo } from "react";
import { FindContasByCategoriaItem } from "core/features/contas-categorias/typings/index";
import { formatMoney } from "infra/helpers/number";
import moment from "moment";
import { OperacaoEnum } from "core/resources/enums/conta";
import { MdOutlineHomeWork } from "react-icons/md";

function useDetalhamentoContaCategoriaColumns(
  operacao: OperacaoEnum | undefined
) {
  return useMemo(() => {
    const tituloTipo =
      operacao === OperacaoEnum.Despesa ? "Favorecido" : "Devedor";

    return [
      {
        title: "Vencimento",
        width: "200px",
        render: (original: FindContasByCategoriaItem) => (
          <>
            {original.dataVencimento ? (
              moment(original.dataVencimento).format("DD/MM/YYYY")
            ) : (
              <Flex justifyContent="center">--</Flex>
            )}
          </>
        ),
      },
      {
        title: "Descrição",

        render: (original: FindContasByCategoriaItem) => (
          <Flex>{original.descricao ? original.descricao : "--"}</Flex>
        ),
      },
      {
        title: tituloTipo,
        width: "200px",
        render: (original: FindContasByCategoriaItem) => (
          <>
            {original.unidade ? (
              <Flex gap="8px" alignItems={"center"}>
                <MdOutlineHomeWork />{" "}
                <Text fontWeight="bold">
                  {original.unidade?.blocoQuadra
                    ? `${original.unidade?.blocoQuadra}, `
                    : ""}
                  {original.unidade?.numero}
                </Text>
              </Flex>
            ) : null}

            {original.pessoa.nome ? original.pessoa.nome : "--"}
          </>
        ),
      },
      {
        title: "Valor",
        render: (original: FindContasByCategoriaItem) => (
          <Flex>{formatMoney(original.valor)}</Flex>
        ),
      },
    ];
  }, [operacao]);
}

export default useDetalhamentoContaCategoriaColumns;
